import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/payroll-engine-mock/_layout/items/$componentId/_layout/reports/')({});